import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import { Preference, CurrentPreference, UserDetails, Token } from '../app.model';
import { CacheService } from '../cache.service';
import { NS_Enums } from '../shared/namespaces';
import { getRolesFromToken } from '../shared/helpers/jwt.helper';

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preferences.component.html',
  styleUrls: ['./user-preferences.component.scss']
})
export class UserPreferencesComponent implements OnInit {
  companyPreferences: Preference[];
  userPreferences: Preference[] = [];
  changedCompanyPreferences: CurrentPreference[] = [];
  changedUserPreferences: CurrentPreference[] = [];
  orgCategories: any = [];
  companyPreferenceTab = 0;
  userDetails: UserDetails = new UserDetails();
  userCategories: any = [];
  userPreferenceTab = 0;
  orgTabValue: number;
  userTabValue: number;
  userRole: any;

  constructor(private appService: AppService, private cacheService: CacheService) { }

  ngOnInit() {
    this.userDetails = this.cacheService.getObject<any>('user_details');
    this.getPreferences();
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    if (saras_auth_key) {
      const rolesFromToken = getRolesFromToken(saras_auth_key.token)
      this.userRole = rolesFromToken
    }
  }

  getPreferences() {
    this.appService.getPreferences(this.userDetails.userId).then((data) => {
      const allPreferences = data;
      const companyPreferences = allPreferences.companyPref;
      const userPreferences = allPreferences.userPref;
      this.arrangeAllPreferences(companyPreferences, userPreferences);
    });
  }

  arrangeAllPreferences(companyPreferences, userPreferences) {
    this.companyPreferences = this.arrangePreferences(companyPreferences, 'company');
    this.userPreferences = this.arrangePreferences(userPreferences, 'user');
  }

  arrangePreferences(preferences, type = 'company') {
    const returnPreferences = [];
    const coveredGroups = [];
    preferences.forEach(preference => {
      if (preference.enforced) {
        preference.selected = true;
      } else {
        preference.selected = false;
      }
      if (coveredGroups.includes(preference.preferenceGroupId)) {
        returnPreferences[coveredGroups.indexOf(preference.preferenceGroupId)].push(preference);
      } else {
        coveredGroups.push(preference.preferenceGroupId);

        if (type === 'company') {
          if (!this.companyPreferenceTab) {
            this.companyPreferenceTab = preference.preferenceGroupId;
            this.orgTabValue = preference.preferenceGroupId;
          }
          this.orgCategories.push(
            {
              preferenceGroupId: preference.preferenceGroupId,
              groupLabel: preference.grouplabel
            }
          );
        }

        if (type === 'user') {
          if (!this.userPreferenceTab) {
            this.userPreferenceTab = preference.preferenceGroupId;
            this.userTabValue = preference.preferenceGroupId;
          }
          this.userCategories.push(
            {
              preferenceGroupId: preference.preferenceGroupId,
              groupLabel: preference.grouplabel
            }
          );
        }

        returnPreferences[coveredGroups.indexOf(preference.preferenceGroupId)] = [];
        returnPreferences[coveredGroups.indexOf(preference.preferenceGroupId)].push(preference);

      }
    });
    return returnPreferences;
  }

  // onTextValueChange(preference: Preference, type) {
  //   if (type === 'company') {
  //     this.changedCompanyPreferences = this.changedPreferences(preference, this.changedCompanyPreferences);
  //   } else if (type === 'user') {
  //     this.changedUserPreferences = this.changedPreferences(preference, this.changedUserPreferences);
  //   }
  // }

  // dont remove below 3 commented methods
  // onCheckBoxChanged(preference: Preference, currentCheckbox, event, type) {
  //   if (type === 'company') {
  //     this.changedCompanyPreferences = this.changedCheckboxPreferences(preference,
  //        this.changedCompanyPreferences, currentCheckbox, event);
  //   } else if (type === 'user') {
  //     this.changedUserPreferences = this.changedCheckboxPreferences(preference,
  //        this.changedUserPreferences, currentCheckbox, event);
  //   }
  // }

  onSwitchChange(preference: Preference , event, type) {
    let postChangedPreferences = [];
    if (type === 'company') {
      postChangedPreferences = this.changedSwitchPreferences(preference, this.changedCompanyPreferences, event);
    } else if (type === 'user') {
      postChangedPreferences = this.changedUserPreferences = this.changedSwitchPreferences(preference, this.changedUserPreferences, event);
    }
    this.appService.updatePreference(this.userDetails.userId, postChangedPreferences).then( data => {
      console.log(data);
    });
  }

  onEnforceChanged(preference: Preference , event, type) {
    let postChangedPreferences = [];
    if (type === 'company') {
      postChangedPreferences  = this.changedEnforcePreferences(preference, this.changedCompanyPreferences, event);
    } else if (type === 'user') {
      postChangedPreferences = this.changedEnforcePreferences(preference, this.changedUserPreferences, event);
    }
    this.appService.updatePreference(this.userDetails.userId, postChangedPreferences).then( data => {
      console.log(data);
    });
  }

  // changedCheckboxPreferences(preference: Preference, changedPreferences: CurrentPreference[], currentCheckbox, event) {
  //   let preferenceFound = false;
  //   changedPreferences.forEach(changedPreference => {
  //     if (preference.type === 'CHECKBOX') {
  //       if (changedPreference.preferenceId === preference.preferenceId) {
  //         changedPreference.value = this.currentPreferenceCheckboxValue(preference, currentCheckbox, changedPreference.value, event);
  //         preferenceFound = true;
  //       }
  //     }
  //   });

  //   if (!preferenceFound) {
  //     const currentPreference = new CurrentPreference();
  //     currentPreference.preferenceId = preference.preferenceId;
  //     currentPreference.entityType = preference.entityType;
  //     currentPreference.enforced = preference.enforced;
  //     currentPreference.value = this.currentPreferenceCheckboxValue(preference, currentCheckbox, '', event);
  //     changedPreferences.push(currentPreference);
  //   }
  //   return changedPreferences;
  // }

  // currentPreferenceCheckboxValue(preference, currentCheckbox, previousSelection, event) {
  //   if (!previousSelection) {
  //     const selectionArray = [];
  //     selectionArray.push(currentCheckbox.group);
  //     const selectionArrayString = selectionArray.toString();
  //     return selectionArrayString;
  //   } else {
  //     if (event.checked) {
  //       const selectionArray = previousSelection.split(',');
  //       selectionArray.push(currentCheckbox.group);
  //       const selectionArrayString = selectionArray.toString();
  //       return selectionArrayString;
  //     } else {
  //       const selectionArray = previousSelection.split(',').filter((value, index, array) => {
  //         return !(value === currentCheckbox.group);
  //       });
  //       const selectionArrayString = selectionArray.toString();
  //       return selectionArrayString;
  //     }
  //   }
  // }

  // changedPreferences(preference: Preference, changedPreferences: CurrentPreference[]) {
  //   let preferenceFound = false;
  //   changedPreferences.forEach(changedPreference => {
  //     if (preference.type === 'TEXT') {
  //       if (changedPreference.preferenceId === preference.preferenceId) {
  //         changedPreference.value = preference.value;
  //         preferenceFound = true;
  //       }
  //     }
  //   });

  //   if (!preferenceFound) {
  //     if (preference.type === 'TEXT') {
  //       const currentPreference = {
  //         preferenceId: preference.preferenceId,
  //         value: preference.value,
  //         entityType: preference.entityType,
  //         enforced: preference.enforced
  //       };
  //       changedPreferences.push(currentPreference);
  //     }
  //   }
  //   return changedPreferences;
  // }


  changedEnforcePreferences(preference: Preference, changedPreferences: CurrentPreference[], event) {
    let preferenceFound = false;
    changedPreferences.forEach(changedPreference => {
      if (preference.type === 'SWITCH') {
        if (changedPreference.preferenceId === preference.preferenceId) {
          changedPreference.enforced = event.checked;
          preferenceFound = true;
        }
      }
    });

    if (!preferenceFound) {
      const currentPreference: CurrentPreference = {
        value: preference.value,
        enforced: event.checked,
        preferenceId: preference.preferenceId,
        entityType: preference.entityType
      };
      changedPreferences.push(currentPreference);
    }
    return changedPreferences;
  }

  changedSwitchPreferences(preference: Preference, changedPreferences: CurrentPreference[], event) {
    let value = '';
    let preferenceFound = false;
    value = (event) ? 'true' : 'false';
    changedPreferences.forEach(changedPreference => {
      if (preference.type === 'SWITCH') {
        if (changedPreference.preferenceId === preference.preferenceId) {
          changedPreference.value = value;
          preferenceFound = true;
        }
      }
    });

    if (!preferenceFound) {
      const currentPreference: CurrentPreference = {
        value: value,
        enforced: preference.enforced,
        preferenceId: preference.preferenceId,
        entityType: preference.entityType
      };
      changedPreferences.push(currentPreference);
    }
    return changedPreferences;
  }
}
